
export default {
    name: "recipe-card",
    props: {
        item: {
            type: Object
        }
    },
}
